/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ticketpagefreeshare3Inputs */

const en_ticketpagefreeshare3 = /** @type {(inputs: Ticketpagefreeshare3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} of them free`)
};

const de_ticketpagefreeshare3 = /** @type {(inputs: Ticketpagefreeshare3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`davon ${i?.count} kostenlos`)
};

/**
* | output |
* | --- |
* | "{count} of them free" |
*
* @param {Ticketpagefreeshare3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagefreeshare3 = /** @type {((inputs: Ticketpagefreeshare3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagefreeshare3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagefreeshare3(inputs)
	return de_ticketpagefreeshare3(inputs)
});
export { ticketpagefreeshare3 as "ticketPageFreeShare" }